
import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { HttpStatusCode } from '@angular/common/http';
import { Router } from '@angular/router';
import { MenuService } from '../services/menu.service';
import { UserInfoDto } from '../../models/user-info';
import { NotificationService } from '../../../shared-services/notifications.service';
import { CommonService } from '../../../shared-services/common.service';
import { MsalService } from '@azure/msal-angular';
import { Location } from '@angular/common';
import { SharedService } from '../../../shared-services/shared.service';
import { MessageService } from '../../../shared-services/message.service';
import { protectedResources } from '../../../auth-config';
import { AuthenticationResult } from '@azure/msal-browser';
import { environment } from '../../../../environments/environment';
import { DataService } from '../../../shared-services/cache-data.service';

declare var $: any;
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  userInfo: any = {
    email: '',
    id: '',
    name: '',
    role: '',
    logo: {
      attachment: '',
      fileName: '',
      mineType: '',
    },
  };

  pic: string | undefined;
  userNameFirstChar: string | undefined;
  userFirstName: string | undefined;
  subscription: any;
  isTerminated: boolean = false;
  isNotAllowed: boolean = false;
  isSuspended: boolean = false;
  constructor(public service: MenuService, private authService: MsalService,
    private router: Router,
    private messageService: MessageService,
    private location: Location, public _sharedService: SharedService,
    private commonService: CommonService,
    private notifyService: NotificationService, public _dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {


  }


  async getUserInfo() {
    let me = this;
    if (!this.location.path().includes('CPO/page/Add')) {
      this.pic = '';
      await this.service.GetUserInfo().then((x: any) => {
        if (x.code == HttpStatusCode.Ok && x.data) {
          sessionStorage.setItem("cpoStatus", x.data.cpoStatus);

          if (x.data.cpoStatus == 2) {
            this.isSuspended = true;
          }

          me.userInfo = { ...this.userInfo, email: x.data.email };
          me.userInfo = { ...this.userInfo, id: x.data.id };
          me.userInfo = { ...this.userInfo, logo: x.data.logo };
          me.userInfo = { ...this.userInfo, name: x.data.name };
          me.userInfo = { ...this.userInfo, role: x.data.role };
          // this.userInfo = x.data;
          if (me.userInfo.logo != null) {
            var attachment = '';
            if (this.userInfo.logo.mineType == 'image/png') {
              attachment = "data:image/png;base64," + this.userInfo.logo.attachment;
            }
            if (this.userInfo.logo.mineType == 'image/jpeg') {
              attachment = "data:image/jpeg;base64," + this.userInfo.logo.attachment;
            }
            this.pic = attachment;
            this._sharedService.logo = attachment;
          }
          if (me.userInfo.name != null) {
            this.userNameFirstChar = this.userInfo.name.charAt(0);
            this.userFirstName = this.userInfo.name.split(' ')[0];
          }
          this.updateView();
        }
        else if (x.code == 400) {
          this.isNotAllowed = true;
        }
        else if (x.code == 410) {
          this.isNotAllowed = true;
          this.isTerminated = true;
        }
      })
    }
  }

  get UserNameLogo() {
    return this._sharedService.GetLoggedInUserLogo() ? this._sharedService.GetLoggedInUserLogo() : sessionStorage.getItem("loggedInUserLogo");
  }
  get LoggedInUserName() {
    return this._sharedService.GetLoggedInUserName() ? this._sharedService.GetLoggedInUserName() : sessionStorage.getItem("loggedInUserName");
  }
  get FirstLetterOfLoggedUser() {
    return this.LoggedInUserName ? this.LoggedInUserName.charAt(0) : '';
  }

  get ObjUserInfo() {
    return this.userInfo;
  }
  async logout() {

    this.userInfo = {
      email: '',
      id: '',
      name: '',
      role: '',
      logo: {
        attachment: '',
        fileName: '',
        mineType: ''
      }
    }
    sessionStorage.removeItem('IsSetToken');
    sessionStorage.removeItem('loggedInUserLogo');
    sessionStorage.removeItem('loggedInUserName');

    await this.service.Logout().then((x: any) => {
      if (x == true) {
        const items: string[] = protectedResources.apiMenueList.scopes.read;
        const account = this.authService.instance.getActiveAccount();
        if (account != null) {
          sessionStorage.removeItem('IsSetToken');
          this.authService.instance.acquireTokenSilent({
            account: account,
            scopes: items
          })
            .then((result: AuthenticationResult) => {
              this.authService.logout({
                postLogoutRedirectUri: environment.redirectUrlForAzure,
                idTokenHint: result.idToken
              });
            })
            .catch((error) => {
              console.log('Error acquiring token:', error);
            });


        }
      }

    })


  }

  get getUserImage(): any {
    return this.pic;
  }
  async changePassword() {
    if (this.userInfo != null && this.userInfo.email != undefined) {
      let x = await this.commonService.UpdatePassword(this.userInfo.email);
      if (x != null && x.code === 200) {
        this.notifyService.showSuccess("Please Check your email to change password", "Success");
      }
      else {
        this.notifyService.showError(x.message, "error");
      }
    }
  }
  async viewProfile() {
    this.router.navigate(['/profile/page/edit'])
  }
   ngOnInit() {

    this.pic = '';
    this.userInfo = {
      email: '',
      id: '',
      name: '',
      role: '',
      logo: {
        attachment: '',
        fileName: '',
        mineType: ''
      }
    }

    // if (!this.location.path().includes('CPO/page/Add')) {
    this._dataService.menu.subscribe(async (x: any) => {
      if (x && x.data) {
        await this.getUserInfo();
      }
    });

    this.messageService.currentMessage.subscribe((message: any) => {
      if (message == "User Profile updated") {
        this.getUserInfo();

      }
    });
    //  }
  }
  updateView() {
    this.cdr.markForCheck();

  }
  get showLoggedActions() {
    return !this.location.path().includes('CPO/page/Add');
  }
  toggleSideBar() {
    $('body')[0].classList.toggle('toggle-sidebar')
  }
}
